import { render, staticRenderFns } from "./RoyStar.vue?vue&type=template&id=2084e292&"
import script from "./RoyStar.vue?vue&type=script&lang=js&"
export * from "./RoyStar.vue?vue&type=script&lang=js&"
import style0 from "./RoyStar.vue?vue&type=style&index=0&id=2084e292&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports